import React from 'react';
import { styled } from '@mui/material/styles';
import { WithToolProps } from './media';
import { IconButton, Stack } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';

const PREFIX = 'withTool';

const classes = {
  wrap: `${PREFIX}-wrap`,
  tool: `${PREFIX}-tool`,
};

const Root = styled('div')(() => ({
  [`&.${classes.wrap}`]: {
    position: 'relative',
  },

  [`& .${classes.tool}`]: {
    position: 'absolute',
    left: 10,
    top: 10,
    display: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.35)',
    borderRadius: '4px',
    padding: '4px',
  },
  [`&:hover .${classes.tool}`]: {
    display: 'flex',
  },
}));

export function withTool<T extends {}>(Component: React.ComponentType<T>) {
  return (props: T & WithToolProps) => {
    const { onDelete, onEdit, ...rest } = props;

    return (
      <Root className={classes.wrap}>
        <Component {...(rest as T)} />
        {(onDelete || onEdit) && (
          <div className={classes.tool}>
            <Stack spacing={2} direction="row">
              {onEdit && (
                <IconButton onClick={onEdit} size="small">
                  <Edit />
                </IconButton>
              )}
              {onDelete && (
                <IconButton onClick={onDelete} size="small">
                  <Delete />
                </IconButton>
              )}
            </Stack>
          </div>
        )}
      </Root>
    );
  };
}
export default withTool;
